import { useMemo } from 'react';
import { useGetServicesTypesQuery } from '@/pages/Fleet/Businesses/services/services-type.service';
import { useGetVehiclesTypesQuery } from '@/pages/Fleet/Vehicles/services/vehicles-types.service';
import { useBusinesses } from '@/pages/Fleet/Businesses/hooks';
import { Option as AutocompleteOption } from '@/components/inputs/AutocompleteInput';

export interface ServicesSearchOptionsResult {
  businessOptions: AutocompleteOption[];
  serviceTypeOptions: AutocompleteOption[];
  vehicleTypeOptions: AutocompleteOption[];
  serviceTypesLoading: boolean;
  vehicleTypesLoading: boolean;
}

export interface UseServicesSearchOptionsParams {
  businessesSearch: string;
}

const useServicesSearchOptions = ({
  businessesSearch,
}: UseServicesSearchOptionsParams): ServicesSearchOptionsResult => {

  const { data: serviceTypes = [], isLoading: serviceTypesLoading } = useGetServicesTypesQuery();
  const { data: vehicleTypes = [], isLoading: vehicleTypesLoading } = useGetVehiclesTypesQuery();
  const { businesses } = useBusinesses({
    search: businessesSearch,
    page: 1,
    pageSize: 10,
  });

  const businessOptions = useMemo<AutocompleteOption[]>(
    () =>
      businesses.map((business) => ({
        label: business.name,
        data: business,
      })),
    [businesses]
  );

  const serviceTypeOptions = useMemo<AutocompleteOption[]>(
    () =>
      serviceTypes.map((serviceType) => ({
        label: serviceType.name,
        data: serviceType,
      })),
    [serviceTypes]
  );

  const vehicleTypeOptions = useMemo<AutocompleteOption[]>(
    () =>
      vehicleTypes.map((vehicleType) => ({
        label: vehicleType.name,
        data: vehicleType,
      })),
    [vehicleTypes]
  );

  return {
    businessOptions,
    serviceTypeOptions,
    vehicleTypeOptions,
    serviceTypesLoading,
    vehicleTypesLoading,
  };
};

export default useServicesSearchOptions;
